var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.66666C6.50016 1.66666 3.3335 4.34998 3.3335 8.49996C3.3335 11.15 5.37516 14.2666 9.45016 17.8583C9.76683 18.1333 10.2418 18.1333 10.5585 17.8583C14.6252 14.2666 16.6668 11.15 16.6668 8.49996C16.6668 4.34998 13.5002 1.66666 10.0002 1.66666ZM10.0002 9.99996C9.0835 9.99996 8.3335 9.24996 8.3335 8.3333C8.3335 7.41663 9.0835 6.66664 10.0002 6.66664C10.9168 6.66664 11.6668 7.41663 11.6668 8.3333C11.6668 9.24996 10.9168 9.99996 10.0002 9.99996Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationSmall);
export default __webpack_public_path__ + "static/media/icon-location-small.64f2bb8aef27c633cf8f626ef00a640c.svg";
export { ForwardRef as ReactComponent };